// Class: motion.easing._Back.BackEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var BackEaseOut = function(s) {
	this.s = s;
}

// Meta

BackEaseOut.__name__ = ["motion","easing","_Back","BackEaseOut"];
BackEaseOut.__isInterface__ = false;
BackEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
BackEaseOut.prototype = {
	calculate: function(k) {
		return --k * k * ((this.s + 1) * k + this.s) + 1;
	},
	ease: function(t,b,c,d) {
		t = t / d - 1;
		return c * (t * t * ((this.s + 1) * t + this.s) + 1) + b;
	}
};
BackEaseOut.prototype.__class__ = BackEaseOut.prototype.constructor = $hxClasses["motion.easing._Back.BackEaseOut"] = BackEaseOut;

// Init



// Statics




// Export

exports.default = BackEaseOut;